const STORAGE_KEY = 'theme'
const media = window.matchMedia('(prefers-color-scheme: dark)')

function savedTheme() {
    try {
        return window.localStorage.getItem(STORAGE_KEY)
    } catch (e) {
        return null
    }
}

export function currentTheme() {
    return document.documentElement.getAttribute('data-theme') || 'light'
}

function apply(theme) {
    document.documentElement.setAttribute('data-theme', theme)
}

export function toggleTheme() {
    const next = currentTheme() === 'dark' ? 'light' : 'dark'
    try {
        window.localStorage.setItem(STORAGE_KEY, next)
    } catch (e) {
        // storage blocked: theme still switches for this page view
    }
    apply(next)
    return next
}

// follow the OS setting until the user picks a theme
media.addListener(e => {
    if (!savedTheme()) apply(e.matches ? 'dark' : 'light')
})

apply(savedTheme() || (media.matches ? 'dark' : 'light'))
